export enum DateFilterType {
    OverDue = 'Overdue',
    Last7Days = 'Last 7 days',
    Last3Days = 'Last 3 days',
    Yesterday = 'Yesterday',
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    Next7Days = 'Next 7 days',
    Custom = 'Custom',
    Day = 'Day',
    ThreeDays = '3 Days',
    WeekDays = 'WeekDays',
    Week = 'Week'
}

export enum SortWorkOrderBy {
    DueDate = 'dueDate',
    CreatedDate = 'createdAt'
}

export type SortWorkOrderType = 'ASC' | 'DESC';

export enum DefaultResource {
    All = 'all',
    Employees = 'employees',
    Contractors = 'contractors',
}
